import {ResponseData} from '@dvrd/fetch';
import React, {PropsWithChildren, useEffect, useState} from 'react';
import {updateContent} from '../../util/contentUtil';
import {ContentMode, Language} from '../../util/enums';
import {ChangeContentContext, ContentContextShape} from '../../util/interfaces';
import {loadContent} from '../../util/requestSender';
import {ContentDef} from '../../util/types';

const initialContext: ContentContextShape = {
    language: Language.NL, contentMode: ContentMode.LIVE, content: {}, onUpdate: () => {
    }, onChangeContext: () => {
    }
};

export const ContentContext = React.createContext(initialContext);

function loadFromStorage(): Language {
    if (!localStorage) return Language.NL;
    return (localStorage.getItem('language') ?? Language.NL) as Language;
}

export default function ContentContextProvider({children}: PropsWithChildren<{}>) {
    const [context, setContext] = useState<ContentContextShape>(
        {...initialContext, language: loadFromStorage(), onUpdate, onChangeContext});

    function onChangeContext(params: ChangeContentContext) {
        setContext((currentContext: ContentContextShape) => ({...currentContext, ...params}));
    }

    function onUpdate(key: string, value: string, language: Language,
                      callback?: (data: ResponseData, response: Response) => void) {
        const content: ContentDef = {...context.content, [key]: {content: value}};
        updateContent(content, language, ContentMode.PREVIEW, (data: ResponseData, response: Response) => {
            if (data.success) callback?.(data, response);
        });
    }

    function _loadContent() {
        loadContent({
            data: {
                language: context.language, content_mode: context.contentMode
            }, callback: (data: ResponseData) => {
                if (data.success) setContext({...context, content: data.content});
            }
        });
    }

    useEffect(() => {
        _loadContent();
    }, [context.language, context.contentMode]);

    return (
        <ContentContext.Provider value={context}>
            {children}
        </ContentContext.Provider>
    );
}